import IntersectionObserverAnimations from './Components/IntersectionObserverAnimations';
import ScrollHandler from "./Components/ScrollHandler.js";
import Lightbox from "./Components/Lighbox.js";

import Menu1 from "./Components/Menu1.js";
import MenuOverlayToggler from "./Components/MenuOverlayToggler.js";

import WPBlockCoverVideo from "./Components/WPBlockCoverVideo.js";
import WPBlockMediaTextVideo from "./Components/WPBlockMediaTextVideo.js";
import WPBlockVideo from "./Components/WPBlockVideo.js";
import WPBlockVimeoEmbed from "./Components/WPBlockVimeoEmbed.js";
import WPBlockYouTubeEmbed from "./Components/WPBlockYouTubeEmbed.js";

import ACFBlockHeroFilm from "./Components/ACFBlockHeroFilm.js";
import ACFBlockVideoOverlay from "./Components/ACFBlockVideoOverlay.js";
import ACFBlockCounters from "./Components/ACFBlockCounters.js";
import ACFBlockServiceProviders from "./Components/ACFBlockServiceProviders.js";
import ACFBlockPressReleases from "./Components/ACFBlockPressReleases.js";
import ACFBlockStories from "./Components/ACFBlockStories.js";
import ACFBlockProductHotspots from "./Components/ACFBlockProductHotspots.js";
import ACFBlockProductFeatures from "./Components/ACFBlockProductFeatures.js";
import ACFBlockProductOptions from "./Components/ACFBlockProductOptions.js";

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-setclasses !*/
!function(n,e,s){function o(n,e){return typeof n===e}function a(){var n,e,s,a,i,l,r;for(var c in f)if(f.hasOwnProperty(c)){if(n=[],e=f[c],e.name&&(n.push(e.name.toLowerCase()),e.options&&e.options.aliases&&e.options.aliases.length))for(s=0;s<e.options.aliases.length;s++)n.push(e.options.aliases[s].toLowerCase());for(a=o(e.fn,"function")?e.fn():e.fn,i=0;i<n.length;i++)l=n[i],r=l.split("."),1===r.length?Modernizr[r[0]]=a:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=a),t.push((a?"":"no-")+r.join("-"))}}function i(n){var e=r.className,s=Modernizr._config.classPrefix||"";if(c&&(e=e.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+s+"no-js(\\s|$)");e=e.replace(o,"$1"+s+"js$2")}Modernizr._config.enableClasses&&(e+=" "+s+n.join(" "+s),c?r.className.baseVal=e:r.className=e)}var t=[],f=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(n,e){var s=this;setTimeout(function(){e(s[n])},0)},addTest:function(n,e,s){f.push({name:n,fn:e,options:s})},addAsyncTest:function(n){f.push({name:null,fn:n})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var r=e.documentElement,c="svg"===r.nodeName.toLowerCase();a(),i(t),delete l.addTest,delete l.addAsyncTest;for(var u=0;u<Modernizr._q.length;u++)Modernizr._q[u]();n.Modernizr=Modernizr}(window,document);

//
// Manage vh unit
const setAppHeights = () => {
	const vh = window.innerHeight * .01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
	document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
};
window.addEventListener('resize', setAppHeights)
setAppHeights();

//
// Enable event listener for pushState
const _wr = (type) => {
	const orig = history[type];
	return function() {
		const rv = orig.apply(this, arguments);
		const e = new Event(type);
		e.arguments = arguments;
		window.dispatchEvent(e);
		return rv;
	};
};
history.pushState = _wr('pushState');
history.replaceState = _wr('replaceState');

//
// Manage IntersectionObservers
const intersectionObserverIsSupported = (!!window.IntersectionObserver || 'IntersectionObserver' in window);
if(intersectionObserverIsSupported) {
	document.body.classList.add('js-intersection-observer');
	new IntersectionObserverAnimations();
}

//
// Blocks
document.querySelectorAll('.wp-block-cover-wrapper.has-video').forEach(block => new WPBlockCoverVideo(block));
document.querySelectorAll('.wp-block-media-text-wrapper.has-video').forEach(block => new WPBlockMediaTextVideo(block));
document.querySelectorAll('.wp-block-embed-vimeo').forEach(block => new WPBlockVimeoEmbed(block));
document.querySelectorAll('.wp-block-embed-youtube').forEach(block => new WPBlockYouTubeEmbed(block));
document.querySelectorAll('.wp-block-video-wrapper:not(.has-autoplay)').forEach(domEl => new WPBlockVideo(domEl));

document.querySelectorAll('.acf-block-hero-film').forEach(block => new ACFBlockHeroFilm(block));
document.querySelectorAll('.acf-block-video-overlay').forEach(block => new ACFBlockVideoOverlay(block));
document.querySelectorAll('.acf-block-counters').forEach(block => new ACFBlockCounters(block));
document.querySelectorAll('.acf-block-service-providers').forEach(block => new ACFBlockServiceProviders(block));
document.querySelectorAll('.acf-block-press-releases').forEach(block => new ACFBlockPressReleases(block));
document.querySelectorAll('.acf-block-stories').forEach(block => new ACFBlockStories(block));
document.querySelectorAll('.acf-block-product-hotspots').forEach(block => new ACFBlockProductHotspots(block));
document.querySelectorAll('.acf-block-product-features').forEach(block => new ACFBlockProductFeatures(block));
document.querySelectorAll('.acf-block-product-options').forEach(block => new ACFBlockProductOptions(block));

//
// Misc.
new Lightbox();

//
// Menus
new MenuOverlayToggler();
new Menu1();

//
// Manage Scroll
new ScrollHandler();

//
// Cookie Compliance
const cookiePrefLinks = document.querySelector('.cookie-preferences a');
if(cookiePrefLinks) {
	cookiePrefLinks.addEventListener('click', (e) => {
		e.preventDefault();
		if(window.CookieInformation && window.CookieConsent) {
			CookieConsent.renew();
		}
		return false;
	});

}
let mci22CookieCatStatistic1stLoad = false;
let mci22CookieCatMarketing1stLoad = false;

window.addEventListener('CookieInformationConsentGiven', (e) => {
	if(CookieInformation.getConsentGivenFor('cookie_cat_statistic')) {
		const blocksOptoutStatistic = document.querySelectorAll('.cookieconsent-optout-statistic');
		blocksOptoutStatistic.forEach((block) => {
			block.style.display = 'none';
		})
		if(!mci22CookieCatStatistic1stLoad) {
			mci22CookieCatStatistic1stLoad = true;
		}
	}

	if(CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
		const blocksOptoutMarketing = document.querySelectorAll('.cookieconsent-optout-marketing');
		blocksOptoutMarketing.forEach((block) => {
			block.style.display = 'none';
		})
		if(!mci22CookieCatMarketing1stLoad) {
			mci22CookieCatMarketing1stLoad = true;
		}
	}

}, false);